import { FC, useEffect } from "react"
import { Delete2Button, DeleteButton, SearchButtonPanel } from "../buttons/iconButtons/action/MainCollection"
import { RotationRightButton } from "../buttons/iconButtons/action/RotationCollection"
import { CopyButton, EmptySquareButton, HighLightButton } from "../buttons/iconButtons/editor/ActionCollection"
import { FilePlusButton } from "../buttons/iconButtons/other/FileAndFolderCollection"
import { PrinterButton } from "../buttons/iconButtons/other/MailCollection"
import Tooltip from "../tooltips/Tooltip"
import BaseCommandsPanel, { ICommandsPanelCheckboxProps, ShowDeletedCheckbox } from "./BaseCommandsPanel"
import styles from "./styles/BaseCommandsPanel.module.scss"
import { useUserContext } from "../../system/providers/userContextProvider"
import { checkActiveCommands } from "../../Business/CommonHelperFunctions"
import { AdditionalButton } from "../buttons/iconButtons/other/PanelCollection"
import { PopoverReport, PopoverReportProps } from "../popoverReport/PopoverReport"

interface IPanelEvent {
    disabled?: boolean
    onClick: () => void
}

interface IPanelEventGroup extends IPanelEvent{
    onSubItemClick?: () => any,
    value?: any
    isVisible?: boolean
}
interface IPanelEventCopy extends IPanelEvent{
    onSubItemClick?: () => any,
    value?: any
    hiddenButton?: boolean
}

interface IDictionaryPanelProps {
    add?: IPanelEvent
    edit?: IPanelEvent
    copy?: IPanelEventCopy
    print?: IPanelEvent
    delete?: IPanelEvent
    restore?: IPanelEvent
    search?: IPanelEvent
    refresh?: IPanelEvent
    showDeleted: ICommandsPanelCheckboxProps
    permission?: IPermission
    groupProcessing?: IPanelEventGroup
    hasActiveFilters?: boolean;
    popOverReport?: PopoverReportProps;
}

// Панель команд на страницах справочников
const DictionaryCommandsPanel: FC<IDictionaryPanelProps> = (props) => {

    const userContext = useUserContext();
    const activeCommands = checkActiveCommands(props.permission as IPermission, userContext.userPermission);

    return (
        <>
            <div className={styles.panelWithControl}>
                <BaseCommandsPanel groups={[
                    [
                        {
                            iconButton: <Tooltip title="Добавить запись">
                                <FilePlusButton sizeVariant="mini" {...{...props.add, disabled: props.add?.disabled || !activeCommands.add}} />
                            </Tooltip>
                        },
                        {
                            iconButton: <Tooltip title="Редактировать запись">
                                <HighLightButton sizeVariant="mini" {...{...props.edit, disabled: props.edit?.disabled || !activeCommands.edit}} />
                            </Tooltip>
                        },
                    ],
                    props.copy?.hiddenButton ? [] :
                    [
                        {
                            iconButton: <Tooltip title="Копировать запись">
                                <CopyButton sizeVariant="mini" {...{...props.copy, disabled: props.copy?.disabled || !activeCommands.copy}} />
                            </Tooltip>
                        }
                    ],
                    props.print?.disabled? []: [
                        {
                            iconButton: <Tooltip title="Печать">
                                <PrinterButton sizeVariant="mini" {...{...props.print, disabled: props.print?.disabled || !activeCommands.print}} />
                            </Tooltip>
                        },
                    ],
                    [
                        {
                            iconButton: <Tooltip title="Удалить запись">
                                <Delete2Button sizeVariant="mini" colorVariant="danger" {...{...props.delete, disabled: props.delete?.disabled || !activeCommands.delete}} />
                            </Tooltip>
                        },
                        {
                            iconButton: <Tooltip title="Восстановить запись">
                                <DeleteButton sizeVariant="mini" colorVariant="success" {...{...props.restore, disabled: props.restore?.disabled || !activeCommands.restore}} />
                            </Tooltip>
                        },
                        {
                            iconButton: <Tooltip title="Поиск">
                                <div style={props.hasActiveFilters ? { backgroundColor: 'rgb(153, 204, 255)', borderRadius: "2px" } : {}}>
                                <SearchButtonPanel sizeVariant="mini" {...{...props.search, disabled: props.search?.disabled || !activeCommands.search}} />
                                </div>
                            </Tooltip>
                        },
                        {
                            iconButton: <Tooltip title="Обновить">
                                <RotationRightButton sizeVariant="mini" {...{...props.refresh, disabled: props.refresh?.disabled || !activeCommands.refresh}} />
                            </Tooltip>
                        }
                    ],
                    props.groupProcessing?.isVisible ?
                        [
                            {
                                iconButton: <Tooltip title={'Групповая обработка'}>
                                    {props.groupProcessing?.value ? <AdditionalButton sizeVariant="mini" {...{ ...props.groupProcessing, disabled: false }} /> : <EmptySquareButton sizeVariant="mini" {...{ ...props.groupProcessing, disabled: false }} />}
                                </Tooltip>
                            }
                        ]
                        :
                        [],
                ].filter(group => group.length > 0)
            } />
                <div className={styles.controlRight}>
                    <ShowDeletedCheckbox {...{...props.showDeleted, disabled: props.showDeleted?.disabled || !activeCommands.showDeleted}} />
                </div>
            </div>
            {props.popOverReport?.items.length ? <div style={{display: 'flex', alignSelf: 'center'}}>
                <PopoverReport
                    label={props.popOverReport.label}
                    items={props.popOverReport?.items ?? []}
                    onItemsChange={props?.popOverReport?.onItemsChange}
                    canRemove={props?.popOverReport?.canRemove}
                />
            </div> : null}
            
        </>
    )
}
export default DictionaryCommandsPanel